import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { AttributeType, getAttributeColor } from "./utils";

interface BayProps {
	attribute?: AttributeType;
	selectedAttribute?: AttributeType;
	onChange: (attribute: AttributeType) => void;
	onDelete: () => void;
	onChangeAllowed: boolean;
}

const Bay = ({ attribute, selectedAttribute, onChange, onDelete, onChangeAllowed }: BayProps) => {

	const [ anchorEl, setAnchorEl ] = useState<HTMLDivElement | null>(null);

	const handleOnClick = (type: AttributeType) => {
		setAnchorEl(null);
		onChange(type);
	};

	return (
		<React.Fragment>
			<Box
				mr={1}
				sx={{
					backgroundColor: attribute ? getAttributeColor(attribute) : "#acacac",
					height: "20px",
					width: "40px",
					transition: "all 0.3s ease",

					"&:hover": onChangeAllowed ? {
						backgroundColor: "#848484",
						cursor: "pointer",
					} : {},
				}}
				onClick={(event: React.MouseEvent<HTMLDivElement>) => {
					if (onChangeAllowed) {
						if (selectedAttribute) {
							if (attribute === selectedAttribute) {
								onDelete();
							} else {
								onChange(selectedAttribute);
							}
						} else {
							setAnchorEl(event.currentTarget);
						}
					}
				}} />

			<Menu anchorEl={anchorEl} open={anchorEl !== null} onClose={() => setAnchorEl(null)}>
				<MenuItem
					disabled={attribute === AttributeType._45ft}
					onClick={() => handleOnClick(AttributeType._45ft)}>
					{intl.formatMessage({ id: "BAYPLAN_45FT_COMPATIBLE" })}
				</MenuItem>

				<MenuItem
					disabled={attribute === AttributeType.Blocked}
					onClick={() => handleOnClick(AttributeType.Blocked)}>
					{intl.formatMessage({ id: "BAYPLAN_BLOCKED" })}
				</MenuItem>

				<MenuItem
					disabled={attribute === AttributeType.Reefer}
					onClick={() => handleOnClick(AttributeType.Reefer)}>
					{intl.formatMessage({ id: "BAYPLAN_REEFER_COMPATIBLE" })}
				</MenuItem>

				<MenuItem
					disabled={attribute === AttributeType.Vertical}
					onClick={() => handleOnClick(AttributeType.Vertical)}>
					{intl.formatMessage({ id: "BAYPLAN_VERTICAL" })}
				</MenuItem>

				{attribute && (
					<React.Fragment>
						<Divider />

						<MenuItem
							onClick={() => {
								setAnchorEl(null);
								onDelete();
							}}>
							<Typography color="error">
								{intl.formatMessage({ id: "DELETE" })}
							</Typography>
						</MenuItem>
					</React.Fragment>
				)}
			</Menu>
		</React.Fragment>
	);
};

export default Bay;
